import { Desktop, Mobile } from "common/MediaQueries"
import { useTypedSelector } from "store"
import TotalPriceDesktop from "./TotalPriceDesktop"
import TotalPriceMobile from "./TotalPriceMobile"

const TotalPrice = () => {
  const { price } = useTypedSelector((state) => state.wizard)

  if (!price) return null

  return (
    <>
      <Mobile>
        <TotalPriceMobile price={price} />
      </Mobile>
      <Desktop>
        <TotalPriceDesktop price={price} />
      </Desktop>
    </>
  )
}

export default TotalPrice
